import React from 'react';
import ReviewStars from '../../../../components/reviewStars/ReviewStars';

const GuidHeaderDetails = ({ guidData }) => {
    return (
        <div className='orgTripDetailsHeadingDiv'>
            <div className='flex'>
                <h1 className='detailsImageDisplayName'>{guidData.title}</h1>
            </div>
            <div>
                <div className='tripBriefInfo'>
                    <span className='tripDetailsSubDetails tripDetailsOrgName'>{guidData?.organizerName ?? 'N/A'}</span>
                    <span className='tripDetailsDot'></span>
                    <span className='tripDetailsSubDetails'>{guidData?.quickView?.duration ?? 'N/A'}</span>
                    {/* <span className='tripDetailsDot'></span> */}
                    {/* <span className='tripDetailsSubDetails'>
                        {dates.length !== 0 && standardDate(dates[0]?.startDate?.split('T')[0])} Onwards
                    </span> */}
                    <span className='tripDetailsDot'></span>
                    <span className='tripDetailsSubDetails'>{guidData?.quickView?.startTime ?? 'N/A'}</span>
                    <span className='tripDetailsDot'></span>
                    <span className='tripDetailsSubDetails'>{guidData?.quickView?.type?.[0] ?? 'N/A'}</span>
                    <span className='tripDetailsDot'></span>
                    <span className='tripDetailsSubDetails'>{guidData?.quickView?.difficulty ?? 'N/A'}</span>
                    <span className='tripDetailsDot'></span>
                    <span className='tripDetailsSubDetails'>
                        <ReviewStars rating={guidData?.rating} className='reviews' />
                        <span>{guidData?.rating ?? 'N/A'}</span>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default GuidHeaderDetails;
